// import Vue from 'vue'
// eslint-disable-next-line no-extend-native
Number.prototype.toPrice = function (end = '', interval = 3, lengthDecimal = 0, separator = ' ', floatingPoint) {
  const re = '\\d(?=(\\d{' + interval + '})+' + (lengthDecimal > 0 ? '\\D' : '$') + ')'
  const num = this.toFixed(Math.max(0, ~~lengthDecimal))
  return (floatingPoint ? num.replace('.', floatingPoint) : num).replace(new RegExp(re, 'g'), '$&' + separator) + end
}
